import { render, staticRenderFns } from "./UserSignerImport.vue?vue&type=template&id=4f5443ec"
import script from "./UserSignerImport.vue?vue&type=script&lang=js"
export * from "./UserSignerImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports